export default class MenuItem {
    constructor(el, parent = null, updateOpenItems) {
        this.DOM = { el: el };
        this.updateOpenItems = updateOpenItems;
        this.menuItem = this.DOM.el.dataset.menuItem;
        this.primary = parent === null;
        this.parent = parent;
        this.siblings = [];
        this.children = [];
        this.DOM.children = document.querySelectorAll(`[data-menu-parent="${this.menuItem}"]`);
        this.DOM.toggles = document.querySelectorAll(`[data-menu-toggle="${this.menuItem}"]`);
        this.DOM.hovers = document.querySelectorAll(`[data-menu-hover="${this.menuItem}"]`);
        this.isOpen = this.DOM.el.classList.contains('is-open');
        this.matchMedia = window.matchMedia(`(min-width: 1280px)`);
        this.isDesktop = this.matchMedia.matches;
        this.transitionDuration = 300;
        this.transitionTimeout = null;
        this.hoverTimeout = null;

        this.init();
    }

    init() {
        this.matchMedia.addEventListener("change", ({ matches }) => this.isDesktop = matches);

        this.DOM.children.forEach((childNode) => {
            this.children.push(new MenuItem(childNode, this, this.updateOpenItems));
        });
        this.children.forEach((child) => {
            child.siblings = this.children.filter((item) => item !== child);
        });

        this.DOM.toggles.forEach((toggleNode) => {
            toggleNode.addEventListener('click', (event) => {
                event.preventDefault();
                this.toggle();
            });

            toggleNode.parentElement.addEventListener('mouseenter', (event) => {
                event.preventDefault();

                if (this.isDesktop) {
                    clearTimeout(this.hoverTimeout);
                    this.hoverTimeout = setTimeout(() => {
                        this.open();
                    }, 150);
                }
            });

            toggleNode.parentElement.addEventListener('mouseleave', (event) => {
                event.preventDefault();

                if (this.isDesktop) {
                    clearTimeout(this.hoverTimeout);
                    this.hoverTimeout = setTimeout(() => {
                        this.close();
                    }, 150);
                }
            });
          
        });
    }

    open() {
        let siblingOpen = false;

        this.isOpen = true;
        this.updateOpenItems(this.menuItem, this.isOpen);

        this.siblings.forEach((sibling) => {
            if (sibling.isOpen) {
                siblingOpen = true;
                sibling.close();
            }
        });

        clearTimeout(this.transitionTimeout);
        this.transitionTimeout = setTimeout(() => {
            this.DOM.el.classList.add('is-visible');
            this.DOM.el.clientHeight;
            this.DOM.el.classList.add('is-open');
        }, siblingOpen ? 300 : 0);
    }

    close() {
        this.children.forEach((child) => child.isOpen && child.close());

        this.isOpen = false;
        this.updateOpenItems(this.menuItem, this.isOpen);

        clearTimeout(this.transitionTimeout);
        this.DOM.el.classList.remove('is-open');
        this.transitionTimeout = setTimeout(() => {
            this.DOM.el.classList.remove('is-visible');
        }, this.transitionDuration);
    }

    toggle() {
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }
}

const body = document.body;
const openItems = {};
let transitionTimeout = null;
const updateOpenItems = (item, open) => {
    openItems[item] = open;
    if (Object.values(openItems).filter(value => value).length > 0) {
        clearTimeout(transitionTimeout);
        body.classList.add('menu-visible');
        body.clientHeight;
        body.classList.add('menu-open');
    } else {
        body.classList.remove('menu-open');
        clearTimeout(transitionTimeout);
        transitionTimeout = setTimeout(() => {
            body.classList.remove('menu-visible');
        }, 300);
    }
}

const menuItemNode = document.querySelector('[data-menu-item="primary"]');
if (menuItemNode !== null) {
    new MenuItem(menuItemNode, null, updateOpenItems);
}
